<template>
  <div class="ml-6 mr-6" :style="navbarWithName ? 'margin-left: 165px !important; margin-right: auto !important;' : ''">
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs class="pa-0 ma-0 my-6 mt-0 pt-0"></v-breadcrumbs>
    <v-btn class="color-avatar3" fab dark fixed bottom right color="primary">
      <v-icon>mdi-chevron-down</v-icon>
    </v-btn>

    <v-layout row wrap class="my-4">
      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select :items="periodeberita" v-model="selectedPeriode" class="elevation-0" label="Periode Berita" background-color="#0471A5" dark dense solo rounded @change="loaddatamonitoring">
        </v-select>
      </v-col>
      <v-col class=" ma-0 pa-0" sm="2">
        <v-btn
          outlined rounded  color="primary" class="mb-2" 
           @click="addMonitoring()"
        >
        <v-icon class="ml-2">mdi-plus</v-icon> Add Monitoring</v-btn>
        
      </v-col>
      <v-col v-show=btnShowActin class=" ma-0 pa-0" sm="2">
        <v-btn
          outlined rounded  color="primary" class="mb-2" 
           @click="suntingMonitoring()"
        >
        <v-icon class="ml-2">mdi-pencil</v-icon> Sunting Monitoring</v-btn>
      </v-col>
      <v-col v-show=btnActionSunting class=" ma-0 pa-0" sm="2">
        <v-btn
          outlined rounded  color="primary" class="mb-2" 
           @click="finishSuntingMonitoring()"
        >
        <v-icon class="ml-2">mdi-check-circle</v-icon> finished updating </v-btn>
      </v-col>
    </v-layout>

    <!-- Tabs for Server Selection -->
    <v-tabs v-model="selectedServer" background-color="#0471A5" dark>
      <v-tab v-for="(server, index) in servers" :key="index">{{ server.NAME_SERVER }}</v-tab>
    </v-tabs>
    
    <v-tabs-items v-model="selectedServer">
      <v-tab-item v-for="(server, index) in servers" :key="index">
        <v-row wrap class="mb-4 "  >
          <v-flex  v-for="(monitor, idx) in server.PAR_MONITORING_SERVERs" :key="idx" lg="4" sm="12" class="chart-container">
            <v-card-title>{{ monitor.NAME }}  
              <v-spacer></v-spacer> <!-- This will push the icons to the right -->
              <v-btn v-show=btnActionChart small class="blue mx-2 elevation-0" @click="updateMonitoringAction(monitor,server.HOST,server.HOST_RANGE)" dark outlined icon color="#fff">
                <v-icon style="font-size: 14px;">mdi-pencil</v-icon>
              </v-btn>

              <v-btn v-show=btnActionChart  small class="red elevation-0" @click="deleteItem(monitor.SEQ_ID)" outlined color="#fff" icon>
                <v-icon  style="font-size: 14px;">mdi-delete-outline</v-icon>
              </v-btn>

            </v-card-title>
            <apexcharts height="240px"
            :type="monitor.TYPE" 
            :options="getChartOptions(monitor)" 
            :series="chartSeries[monitor.SEQ_ID] "></apexcharts>
          </v-flex>
        </v-row>
      </v-tab-item>
    </v-tabs-items>



    <!-- dialog action monitorinhg  -->
    <v-dialog v-model="dialogactionmonitoring" max-width="100%">
      <v-card>
        <v-card-title>
          <span class="text-h6">Chart Monitoring Server</span>
        </v-card-title>
        <v-card-text class="overflow-card">
          <v-layout row wrap class="my-6">
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="serversSelect"
                item-text="NAME_SERVER"
                item-value="SEQ_ID"
                v-model="selectedServerId"
                @change="sendtmp"
                label="Choose Server"
              />
            </v-col>
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="itemtypechart"
                item-text="chart"
                v-model="typechart"
                
                @change="selecttypechart"
                label="Type"
              />
            </v-col>

            <v-col v-if="donut_attr"  class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="itemtypeDonut"
                item-text="chart"
                v-model="nameChartDonut"
                label="Name Chart"
              />
            </v-col>
            <v-col v-if="area_attr" class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                :items="matricexplorer"
                item-text="MATRIC"
                item-value="SEQ_ID_MATRIC"
                v-model="matricexplorerAdd"
                label="Matric Explorer"
              />
            </v-col>
            <v-col v-if="area_attr" class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-text-field
                class="elevation-0 shadow-0"
                dense
                outlined
                rounded
                v-model="namechart"
                label="name Chart"
              />
            </v-col>

            <v-col class="d-flex ma-0 pa-0" sm="2">
              <v-btn
                color="green darken-1"
                style="width: 130px;"
                rounded
                dark
                dense
                :loading="btnload"
                @click="displayMonitoring"
              >
                Display
              </v-btn>
            </v-col>

          </v-layout>
        </v-card-text>
          
        <!-- Dynamic Chart Display -->
        <v-flex lg="12" sm="12" class="chart-container">
          <v-card-title>{{ name_title_monitoring }}</v-card-title>
          <div  :class="{'d-flex': type_chart_display === 'donut', 'justify-center align-center': type_chart_display === 'donut'}" style="width: 100%;">
            <apexchart
            style="height: 10px;"
              class="mr-3"
              :type="type_chart_display"
              :options="chart_display"
              :series="series_display"
            ></apexchart>
          </div>
        </v-flex>
        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            style="width: 90px;"
            rounded
            outlined
            dense
            @click="closeMonitoringAction"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            style="width: 90px;"
            rounded
            dark
            dense
            :loading="btnload"
            @click="postDataMonitoring"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLoading" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">Page loading</v-card-title>
        <v-card-text class="body-1 align-center justify-center">Loading content, please wait</v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialogLoading = false">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogDelete" width="330px">
      <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
        <v-avatar class="color-avatar3 my-4" size="62">
          <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
        </v-avatar>
        <div class="text-center text-h6 align-center justify-center font-weight-medium">
          Confirm Deletion
        </div> 
        <v-card-text class="align-center justify-center mt-2">
          Are you sure you want to delete this chart ?
        </v-card-text>
        <v-divider class="mt-4" style=""></v-divider>
        <v-card-actions class="align-center justify-center">
          <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
            OK
          </v-btn>
          <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
            Cancel 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

import { decryptionData } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      btnShowActin:true,
      btnActionSunting:false,
      btnActionChart:false,

      matricexplorer:[],
      matricexplorerAdd:'',
      seqId:"",
      namechart:"",
      selectedServerId:null,
      tmp_server:null,
      tmp_host:null,
      tmp_host_range:null,
      btnload:false,
      dialogactionmonitoring:false,
      setTanggal: [],
      selectedPeriode: "Today",
      dateStart: "",
      dateEnd: "",
      periodeberita: [
        "Today", "Yesterday", "Last 7 Days", "Previous Week", "Last 30 Days", "Previous Month",
      ],
      name_title_monitoring: '',
      series_display: [],
      chart_display: {},
      type_chart_display:"",
      itemtypechart: [
        { chart: 'Donut', value: 'donut' },
        { chart: 'Area', value: 'area' }
      ],
      nameChartDonut:"",
      itemtypeDonut: [
        { chart: 'Memory Usag', value: 'Memory Usag' },
        { chart: 'Swap Space', value: 'Swap Space' },
        { chart: 'File Descriptor Count', value: 'File Descriptor Count' }
      ],
      donut_attr: false,
      area_attr:false,
      

      typechart:"",
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      showDate1: "",
      showDate2: "",
      dialogLoading: false,
      dialogDelete: false,
      alert: false,
      message: "",
      serversSelect: [],
      servers: [],
      selectedServer: 0,
      chartSeries: {},  // Initial values for "Used" and "Free" memory
      totalSwapGb:0,
      totalSwap: 0,
      usedSwap: 0,
      freeSwap: 0,
      // == memory 
      chartOptions: '',
      // == swap 
      chartSwapSeries: [0, 0],  // Initial values for "Used" and "Free" memory
      chartSwapOptions:"",

      // == file count 
      chartFileCountSeries: [0, 0],  // Initial values for "Used" and "Free" memory
      chartFileCountOptions: '',

    };
  },
  computed: {
    ...mapGetters(['navbarWithName']),
  },
  mounted() {
    this.loaddatamonitoring();
  },
  
  watch: {
    dialogactionmonitoring (val) {
      val || this.closeMonitoringAction()
    },
    
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },
  methods: {
    getChartOptions(monitor) {
      let label = [];
      let unit = " GB"
      if(monitor.TYPE == 'donut'){
        
          if (monitor.NAME === 'Memory Usag') {
            label = ['Memory Used', 'Free Memory'];
          }
          if (monitor.NAME === 'Swap Space') {
            label = ['Used Swap', 'Free Swap'];
          }
          
          if (monitor.NAME === 'File Descriptor Count') {
            label = ['Used File Count', 'Availabel File Count'];
            unit = " Mil"
          }
          return {
            labels: label,
            legend: {
                  position: 'bottom',
                },
                
            tooltip: {
              y: {
                formatter: function (val) {
                  return `${val} `+unit; // Show GB in tooltip
                }
              }
            },
            
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      show: true,
                      fontSize: '22px',
                      color: '#226077',
                      offsetY: -10,
                    },
                    total: {
                      show: true,
                      formatter: function (w) {
                        // Format the total value to two decimal places
                        return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + unit; // Example: Show in GB
                      }
                    },
                  }
                }
              }
            },
          };
        }else{
            return {
              
                name: 'Available Memory',
                chart: {
                  id: monitor.SEQ_ID,
                  type: 'area', 
                  animations: {
                    enabled: true,
                    // easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  zoom: {
                    enabled: false
                  }
                },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  curve: 'smooth',
                  colors: ['#00E396', '#FF4560'],
                },
                xaxis: {
                  type: 'datetime', // For time series data
                },
                yaxis: {
                  title: {
                    text: 'Memory (GB)',
                  },
                },
                tooltip: {
                  x: {
                    format: 'dd MMM yyyy HH:mm:ss', // Format for datetime tooltip
                  },
                  y: {
                    formatter: function (val) {
                      return `${val} GB`;
                    }
                  },
                },
                legend: {
                  position: 'top',
                },
            };


        }
    },
    async getChartData(server, monitor) {
        let prometheusUrlRange = server.HOST_RANGE;
        let prometheusUrl = server.HOST;
        const datest = new Date(this.dateStart + 'T00:00:00Z');
        const unixTimestamp = datest.getTime() / 1000;
        const startdate = unixTimestamp + 0.24;
        const date_end = new Date(this.dateEnd + 'T23:59:59Z');
        const unixTimestamp_end = date_end.getTime() / 1000;
        const enddate = unixTimestamp_end + 0.24;

        if (monitor.NAME === 'Memory Usag') {
          try {
            const totalMemoryQuery = 'node_memory_MemTotal_bytes';
            const freeMemoryQuery = 'node_memory_MemFree_bytes';

            const totalMemoryResponse = await axios.get(prometheusUrlRange, {
              params: { 
                query: totalMemoryQuery,
                start: startdate,
                end: enddate,
                step: 300
              },
            });

            const freeMemoryResponse = await axios.get(prometheusUrlRange, {
              params: { 
                query: freeMemoryQuery,
                start: startdate,
                end: enddate,
                step: 300
              },
            });

            const totalMemoryData = totalMemoryResponse.data.data.result;
            const freeMemoryData = freeMemoryResponse.data.data.result;

            let totalMemory = "";
            if (totalMemoryData && totalMemoryData.length > 0 && totalMemoryData[0].values.length > 0) {
              totalMemory = parseFloat(totalMemoryData[0].values[totalMemoryData[0].values.length - 1][1]);
            } else {
              console.error('Error: Total memory data is missing or empty');
            }

            let freeMemory = "";
            if (freeMemoryData && freeMemoryData.length > 0 && freeMemoryData[0].values.length > 0) {
              freeMemory = parseFloat(freeMemoryData[0].values[freeMemoryData[0].values.length - 1][1]);
            } else {
              console.error('Error: Free memory data is missing or empty');
            }

            if (typeof totalMemory === 'number' && typeof freeMemory === 'number') {
              const usedMemory = totalMemory - freeMemory;
              const freeMemoryInGB = (freeMemory / (1024 * 1024 * 1024)).toFixed(2);
              const usedMemoryGB = (usedMemory / (1024 * 1024 * 1024)).toFixed(2);
              
              const chartData = [parseFloat(usedMemoryGB), parseFloat(freeMemoryInGB)];
              
              this.$set(this.chartSeries, monitor.SEQ_ID, chartData); 
              return chartData;
            }

          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30, 20];  // Default value in case of error
          }

        }else  if (monitor.NAME === 'Swap Space') {
          try {
              //====== swap memory ====
              const totalSwapQuery = 'node_memory_SwapTotal_bytes';
              const usedSwapQuery = 'node_memory_SwapUsed_bytes';
              const freeSwapQuery = 'node_memory_SwapFree_bytes';
              const totalSwapResponse = await axios.get(prometheusUrl, {
                params: { 
                  query: totalSwapQuery
                },
              });

              const usedSwapResponse = await axios.get(prometheusUrl, {
                params: { 
                  query: usedSwapQuery
                },
              });
              const freeSwapResponse = await axios.get(prometheusUrl, {
                params: { 
                  query: freeSwapQuery
                },
              });
              let totalSwap = 0;
              let usedSwap = 0;
              let freeSwap = 0;
              if (totalSwapResponse.data.data.result.length > 0) {
                totalSwap = parseFloat(totalSwapResponse.data.data.result[0].value[1]);
              }
              if (freeSwapResponse.data.data.result.length > 0) {
                freeSwap = parseFloat(freeSwapResponse.data.data.result[0].value[1]);
              }
              // Calculate the free swap space as totalSwap - usedSwap if it's not available
              if (isNaN(freeSwap) && !isNaN(totalSwap) && !isNaN(usedSwap)) {
                freeSwap = totalSwap - usedSwap;
              }
              if (usedSwapResponse.data.data.result.length > 0) {
                usedSwap = parseFloat(usedSwapResponse.data.data.result[0].value[1]);
              }else{
                usedSwap = totalSwap - freeSwap;
              }
              // Store the swap data
              this.totalSwap = totalSwap;
              this.usedSwap = usedSwap;
              this.freeSwap = freeSwap;
              const usedSwapInGB = (this.usedSwap / (1024 * 1024 * 1024)).toFixed(2); // Used Swap in GB
              const freeSwapInGB = (this.freeSwap / (1024 * 1024 * 1024)).toFixed(2); // Free Swap in GB
              this.totalSwapGb = (this.totalSwap / (1024 * 1024 * 1024)).toFixed(2); // Total Swap in GB
              const chartData2  = [parseFloat(usedSwapInGB), parseFloat(freeSwapInGB)];
              
              this.$set(this.chartSeries, monitor.SEQ_ID, chartData2); 
              
              return chartData2;
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30];  // Default value in case of error
          }
        }else  if (monitor.NAME === 'File Descriptor Count') {
          // ==== file count ====
          try {

              const fileAvail = 'node_memory_Active_file_bytes';
              const filefree = 'node_memory_Inactive_file_bytes';
              const countavail = await axios.get(prometheusUrl, {
                params: { 
                  query: fileAvail
                },
              });
              const countUsed = await axios.get(prometheusUrl, {
                params: { 
                  query: filefree
                },
              });
              // Mengekstrak nilai dari respons Prometheus (value[1] adalah nilai metrik)
              let availCount = parseFloat(countavail.data.data.result[0].value[1]);
              let usedCount = parseFloat(countUsed.data.data.result[0].value[1]);
              
              if (parseFloat(usedCount) >= 1000000) {
                usedCount = (parseFloat(usedCount) / 1000000).toFixed(2) + ' Mil'; 
              }
              
              if (parseFloat(availCount) >= 1000000) {
                availCount = (parseFloat(availCount) / 1000000).toFixed(2) + ' Mil'; 
              }

              const chartFileCountSeries = [parseFloat(usedCount), parseFloat(availCount)];
              this.$set(this.chartSeries, monitor.SEQ_ID, chartFileCountSeries); 
              return chartFileCountSeries;
              
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30];  // Default value in case of error
          }

        }else {
          try {

            
            let dataquery = await axios.get(prometheusUrlRange, {
              params: { 
                query: monitor.QUERY,
                start: startdate,
                end: enddate,
                step:300
              },
            });
            // Menangani data yang dikembalikan
            let data = dataquery.data.data.result[0].values;  // Mengambil values dari response
            let chartData = [{
              name: monitor.SEQ_ID,  // Nama seri
              data: data.map(item => {
                let timestamp = new Date(item[0] * 1000);
                let memoryInGB = item[1] / (1024 * 1024 * 1024);
                return [timestamp.getTime(), parseFloat(memoryInGB).toFixed(2)];
              })
            }];
            this.$set(this.chartSeries, monitor.SEQ_ID, chartData); 
            console.log(chartData)
            return chartData;
          } catch (error) {
            console.error('Error fetching monitoring data:', error);
            return [50, 30];  // Default value in case of error
          }
        }
    },

    extractMemoryValue(data) {
      if (data && data.length > 0 && data[0].values.length > 0) {
        return parseFloat(data[0].values[data[0].values.length - 1][1]);
      }
      console.error('Error: Monitoring data is missing or empty');
      return 0;
    },

    async loaddatamonitoring() {
      const date_awal = new Date();
        const date = new Date();
        date.setDate(date.getDate()+0);
        const datenow = date.toISOString().substr(0, 10);
        if (this.selectedPeriode == "Today") {
          this.click = 'Today'
          this.dateStart = datenow;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Yesterday") {
          this.click = 'Yesterday'
          date_awal.setDate(date_awal.getDate()-1);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = date_c;
        }
        if (this.selectedPeriode == "Last 7 Days" ||  this.selectedPeriode == "Previous Week") {
          this.click = 'Last 7 Days'
          date_awal.setDate(date_awal.getDate()-7);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
          this.click = 'Last 30 Days'
          date_awal.setDate(date_awal.getDate()-30);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = datenow;
        }
      this.dialogLoading = true;
      
      const response = await axios.get('http://172.20.4.13:9090/api/v1/label/__name__/values');
      // console.log('Metrik yang tersedia:', response.data.data);  // Menampilkan daftar metrik
        // Misalnya ini adalah data yang diterima dari API
      const metricData = response.data.data;

      // Memformat data agar sesuai dengan format yang dibutuhkan oleh v-select
      this.matricexplorer = metricData.map((item) => ({
        MATRIC: item,
        SEQ_ID_MATRIC: item // Atau ID lainnya yang relevan
      }));
      const result = await axios.post(
        'monitoring', // URL endpoint
        {}, // Data yang dikirimkan (kosong jika tidak ada data yang dikirim)
        {
          headers: {
            'auth-token': localStorage.getItem('token_app')
          },
          // Axios secara otomatis mengonversi respons ke JSON, jadi tidak perlu menambahkan 'dataType: 'json''
        }
      );
      

      var data = decryptionData(result.data);
      this.serversSelect = data.data.dataServer
      this.servers = data.data.dataMonitoring
      let dataMonitoring = data.data.dataMonitoring
      dataMonitoring.forEach((server) => {
        server.PAR_MONITORING_SERVERs.forEach((monitor) => {
          this.getChartData(server, monitor);
        });
      });
      this.dialogLoading = false;
    },

    // add =========================================
    // add =========================================
    // add =========================================
    
    async selecttypechart() {
        if(this.typechart == "donut"){
          this.donut_attr = true
          this.area_attr = false
        }else {
          this.donut_attr = false
          this.area_attr = true
        }
      },
    addMonitoring(){
      this.dialogactionmonitoring = true
    },
    
    suntingMonitoring(){
      this.btnShowActin = false
      this.btnActionSunting = true
      this.btnActionChart = true
    },
    
    finishSuntingMonitoring(){
      this.btnShowActin = true
      this.btnActionSunting = false
      this.btnActionChart = false
    },
    
    deleteItem(seq_id){ 
      this.seqId = seq_id
      this.dialogDelete = true
    },
    
    closeDelete () {
        this.dialogDelete = false
        this.seqId = ""
        this.btnload = false

    },
    
    deleteItemConfirm () {
      this.dialogLoading = true;

      axios({
        method: "delete",
        url: "/monitoring/delete",
        data: {
          id: this.seqId
        },
        headers:{'auth-token':localStorage.getItem('token_app')},
        dataType: 'json'
      })
      .then((response) => {
        // handle success
        this.loaddatamonitoring();
            var status = response.data.status
            var messages = response.data.msg
            if(status == 200){
              this.alertSuccess = true;
              this.alert_err_attention =  messages;
              this.btnload = false
              this.closeDelete()
            }else{
                this.alertFailed = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeDelete()
            } 
      this.dialogLoading = false;

      })
      .catch(function (error) {
        console.log(error);
        this.alertFailed = true;
        this.alert_err_attention =  'Delete Failed';
        this.btnload = false
      this.dialogLoading = false;

      })
    },
    sendtmp(selectedSeqId) {
      this.tmp_server = this.serversSelect.find(
        server => server.SEQ_ID === selectedSeqId
      );

      if (this.tmp_server) {
        this.tmp_host = this.tmp_server.HOST
        this.tmp_host_range = this.tmp_server.HOST_RANGE
      } else {
        console.log('No item selected');
      }
    },
    
















    async displayMonitoring() {
      const datest = new Date(this.dateStart + 'T00:00:00Z');
        const unixTimestamp = datest.getTime() / 1000;
      const startdate = unixTimestamp + 0.24;
        const date_end = new Date(this.dateEnd + 'T23:59:59Z');
        const unixTimestamp_end = date_end.getTime() / 1000;
        const enddate = unixTimestamp_end + 0.24;
      if (this.typechart === 'donut') {
            if (this.nameChartDonut === 'Memory Usag') {
              try {
                const totalMemoryQuery = 'node_memory_MemTotal_bytes';
                const freeMemoryQuery = 'node_memory_MemFree_bytes';

                const totalMemoryResponse = await axios.get(this.tmp_host_range, {
                  params: { 
                    query: totalMemoryQuery,
                    start: startdate,
                    end: enddate,
                    step: 300
                  },
                });

                const freeMemoryResponse = await axios.get(this.tmp_host_range, {
                  params: { 
                    query: freeMemoryQuery,
                    start: startdate,
                    end: enddate,
                    step: 300
                  },
                });

                const totalMemoryData = totalMemoryResponse.data.data.result;
                const freeMemoryData = freeMemoryResponse.data.data.result;

                let totalMemory = "";
                if (totalMemoryData && totalMemoryData.length > 0 && totalMemoryData[0].values.length > 0) {
                  totalMemory = parseFloat(totalMemoryData[0].values[totalMemoryData[0].values.length - 1][1]);
                } else {
                  console.error('Error: Total memory data is missing or empty');
                }

                let freeMemory = "";
                if (freeMemoryData && freeMemoryData.length > 0 && freeMemoryData[0].values.length > 0) {
                  freeMemory = parseFloat(freeMemoryData[0].values[freeMemoryData[0].values.length - 1][1]);
                } else {
                  console.error('Error: Free memory data is missing or empty');
                }

                if (typeof totalMemory === 'number' && typeof freeMemory === 'number') {
                  const usedMemory = totalMemory - freeMemory;
                  const freeMemoryInGB = (freeMemory / (1024 * 1024 * 1024)).toFixed(2);
                  const usedMemoryGB = (usedMemory / (1024 * 1024 * 1024)).toFixed(2);
                  
                  this.series_display = [parseFloat(usedMemoryGB), parseFloat(freeMemoryInGB)];
                  this.chart_display = {
                    chart: {
                      type: 'donut',
                      height: 300,
                    },
                    labels: ['Used Swap', 'Free Swap'],
                    
                    legend: {
                          position: 'bottom',
                        },
                        
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          return `${val} GB`; // Show GB in tooltip
                        }
                      }
                    },
                    
                    plotOptions: {
                      pie: {
                        donut: {
                          labels: {
                            show: true,
                            name: {
                              show: true,
                              fontSize: '22px',
                              color: '#226077',
                              offsetY: -10,
                            },
                            total: {
                              show: true,
                              formatter: function (w) {
                                // Format the total value to two decimal places
                                return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + ' GB'; // Example: Show in GB
                              }
                            },
                          }
                        }
                      }
                    },
                  };
                  
                }

              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30, 20];  // Default value in case of error
              }

            }else  if (this.nameChartDonut === 'Swap Space') {
              try {
                  //====== swap memory ====
                  const totalSwapQuery = 'node_memory_SwapTotal_bytes';
                  const usedSwapQuery = 'node_memory_SwapUsed_bytes';
                  const freeSwapQuery = 'node_memory_SwapFree_bytes';
                  const totalSwapResponse = await axios.get(this.tmp_host, {
                    params: { 
                      query: totalSwapQuery
                    },
                  });

                  const usedSwapResponse = await axios.get(this.tmp_host, {
                    params: { 
                      query: usedSwapQuery
                    },
                  });
                  const freeSwapResponse = await axios.get(this.tmp_host, {
                    params: { 
                      query: freeSwapQuery
                    },
                  });
                  let totalSwap = 0;
                  let usedSwap = 0;
                  let freeSwap = 0;
                  if (totalSwapResponse.data.data.result.length > 0) {
                    totalSwap = parseFloat(totalSwapResponse.data.data.result[0].value[1]);
                  }
                  if (freeSwapResponse.data.data.result.length > 0) {
                    freeSwap = parseFloat(freeSwapResponse.data.data.result[0].value[1]);
                  }
                  // Calculate the free swap space as totalSwap - usedSwap if it's not available
                  if (isNaN(freeSwap) && !isNaN(totalSwap) && !isNaN(usedSwap)) {
                    freeSwap = totalSwap - usedSwap;
                  }
                  if (usedSwapResponse.data.data.result.length > 0) {
                    usedSwap = parseFloat(usedSwapResponse.data.data.result[0].value[1]);
                  }else{
                    usedSwap = totalSwap - freeSwap;
                  }
                  // Store the swap data
                  this.totalSwap = totalSwap;
                  this.usedSwap = usedSwap;
                  this.freeSwap = freeSwap;
                  const usedSwapInGB = (this.usedSwap / (1024 * 1024 * 1024)).toFixed(2); // Used Swap in GB
                  const freeSwapInGB = (this.freeSwap / (1024 * 1024 * 1024)).toFixed(2); // Free Swap in GB
                  this.totalSwapGb = (this.totalSwap / (1024 * 1024 * 1024)).toFixed(2); // Total Swap in GB
                  this.series_display  = [parseFloat(usedSwapInGB), parseFloat(freeSwapInGB)];
                  this.chart_display = {
                    chart: {
                      type: 'donut',
                      height: 300,
                    },
                    labels: ['Used Swap', 'Free Swap'],
                     
                    legend: {
                          position: 'bottom',
                        },
                        
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          return `${val} GB`; // Show GB in tooltip
                        }
                      }
                    },
                    
                    plotOptions: {
                      pie: {
                        donut: {
                          labels: {
                            show: true,
                            name: {
                              show: true,
                              fontSize: '22px',
                              color: '#226077',
                              offsetY: -10,
                            },
                            total: {
                              show: true,
                              formatter: function (w) {
                                // Format the total value to two decimal places
                                return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + ' GB'; // Example: Show in GB
                              }
                            },
                          }
                        }
                      }
                    },
                  };
              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30];  // Default value in case of error
              }
            }else  if (this.nameChartDonut === 'File Descriptor Count') {
              // ==== file count ====
              try {

                  const fileAvail = 'node_memory_Active_file_bytes';
                  const filefree = 'node_memory_Inactive_file_bytes';
                  const countavail = await axios.get(this.tmp_host, {
                    params: { 
                      query: fileAvail
                    },
                  });
                  const countUsed = await axios.get(this.tmp_host, {
                    params: { 
                      query: filefree
                    },
                  });
                  // Mengekstrak nilai dari respons Prometheus (value[1] adalah nilai metrik)
                  let availCount = parseFloat(countavail.data.data.result[0].value[1]);
                  let usedCount = parseFloat(countUsed.data.data.result[0].value[1]);
                  
                  if (parseFloat(usedCount) >= 1000000) {
                    usedCount = (parseFloat(usedCount) / 1000000).toFixed(2) + ' Mil'; 
                  }
                  
                  if (parseFloat(availCount) >= 1000000) {
                    availCount = (parseFloat(availCount) / 1000000).toFixed(2) + ' Mil'; 
                  }
                  this.series_display = [parseFloat(usedCount), parseFloat(availCount)];
                  this.chart_display = {
                    chart: {
                      type: 'donut',
                      height: 300,
                    },
                    labels: ['Used File Descriptors', 'Available File Descriptors'],
                     
                    legend: {
                          position: 'bottom',
                        },
                        
                    tooltip: {
                      y: {
                        formatter: function (val) {
                          
                              if (val >= 1000000) {
                                return (val / 1000000).toFixed(2) + ' Mil'; 
                              }
                              return val.toFixed(2) + ' Mil'; 
                        }
                      }
                    },
                    
                    plotOptions: {
                      pie: {
                        donut: {
                          labels: {
                            show: true,
                            name: {
                              show: true,
                              fontSize: '22px',
                              color: '#226077',
                              offsetY: -10,
                            },
                            total: {
                              show: true,
                              formatter: function (w) {
                                const totalValue = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                if (totalValue >= 1000000) {
                                  const totalInMillions = (totalValue / 1000000).toFixed(2);
                                  return totalInMillions + ' Mil';
                                }
                                return totalValue.toFixed(2)+ ' Mil'; 
                              }
                            },
                          }
                        }
                      }
                    },
                  };
              } catch (error) {
                console.error('Error fetching monitoring data:', error);
                return [50, 30];  // Default value in case of error
              }

            }
            this.type_chart_display = 'donut';
      } else if (this.typechart === 'area') {
        
        this.chart_display = {}
                  // Fetch Prometheus data for the area chart
          const dataquery = await axios.get(this.tmp_host_range, {
            params: {
              query: this.matricexplorerAdd,
              start: startdate,
              end: enddate,
              step: 300  // 300 seconds (5 minutes) step interval
            },
          });

          // Extract time-series data for the area chart
          const series = [];
          const timestamps = [];
          // Loop through the results and prepare the data for the chart
          dataquery.data.data.result.forEach((metricData) => {
            const dataPoints = [];
            metricData.values.forEach(([timestamp, value]) => {
              const date = new Date(timestamp * 1000); // Convert to milliseconds
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
              const year = date.getFullYear();
              const hours = String(date.getHours()).padStart(2, '0');
              const minutes = String(date.getMinutes()).padStart(2, '0');
              const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
              timestamps.push(formattedDate);
              dataPoints.push(parseFloat(value));
            });

            series.push({
              name: metricData.metric.__name__, // Metric name as the series name
              data: dataPoints
            });
          });
          this.chart_display = {
            chart: {
              type: 'area',
              height: 300,
            },
            xaxis: {
              categories: timestamps // Set categories (timestamps) for the x-axis
            },
            series: series
          };
        this.type_chart_display = 'area';
      }
      // Set the title dynamically based on the type of chart
      this.name_title_monitoring = `${this.typechart.charAt(0).toUpperCase() + this.typechart.slice(1)} Chart`;
    },

    closeMonitoringAction () {
      this.seqId =""
      this.series_display =[]
      this.chart_display ={}
      this.type_chart_display =""
      this.name_title_monitoring =""
      

      this.dialogactionmonitoring =false
      this.btnload = false

    },
    updateMonitoringAction (data,host,hostRange) {
      this.seqId =data.SEQ_ID
      this.selectedServerId = data.SEQ_ID_MONITORING_SERVER
      this.typechart = data.TYPE
      if(data.TYPE == 'donut'){
        this.nameChartDonut = data.NAME
        this.donut_attr = true
        this.area_attr = false
      }else{
        this.matricexplorerAdd = data.QUERY
        this.namechart = data.NAME
        this.donut_attr = false
        this.area_attr = true
      }
      this.tmp_host = host
      this.tmp_host_range = hostRange
      this.dialogactionmonitoring =true
      this.displayMonitoring();
    },
    async postDataMonitoring () {
      this.btnload = true
      
      let nameChart = this.namechart
      let flagManual = 'Y'
      if(this.typechart == 'donut'){
        nameChart = this.nameChartDonut
        flagManual = 'N'
      }
      axios.post("/monitoring-action", 
      {
          seqId :this.seqId,
          seqIdMonitoringServer :this.selectedServerId,
          nameChart : nameChart,
          flagManual : flagManual,
          query : this.matricexplorerAdd,
          type : this.typechart,
          
        },
        { headers:{'auth-token':localStorage.getItem('token_app')}},
        {dataType: 'json'}
        )
      .then((response) => {
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.loaddatamonitoring();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.btnload = false
            this.closeMonitoringAction();
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
              this.btnload = false
          } 
        })
      .catch((e) => {
            switch (e.response.status) {
                case 404:
                      this.$refs.alert.error_login(404);
                    break;
                case 403:
                      this.$refs.alert.error_login(403);
                    break;
                case 400:
                      this.alertFailed = true;
                      this.alert_err_attention =  e.response.data.msg;
                      this.btnload = false
                    break;
                default:
                    console.log('some other error');  // end up here all the time
                    break;
                }
        this.errors=e.response.data.msg;
      });  
    },
    
  },
};
</script>

<style> /*note css jangan diubah*/

.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.chart-container {
  
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);
  /* padding: 10px; */
  border-radius: 8px; /* Rounded corners */
  margin-bottom: 10px; /* Margin below each chart */
  margin-left: 10px;   /* Margin on the left of each chart */
  margin-right: 10px;  /* Margin on the right of each chart */
}

/* Targeting specific classes */
.apexcharts-canvas {
  width: 100% !important; 
  margin-left: 5px;
  margin-right: 5px;
  height: 250px !important;
}
.apexcharts-svg {
  margin: 0;
}
.apexchartsavailable-memory-line-chart {
  /* Adjust width, margin or padding if needed */
  width: 100% !important; 
  height: 240px !important; /* Adjust height if necessary */
}
.apexcharts-theme-light .apexcharts-xaxis-texts tspan {
  /* Example of changing text color of X-axis labels */
  fill: #226077;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}

.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}

.v-avatar.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}
</style>